import React from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useDependencyInjector } from "@whatslly/commons/di";
import type { FormTextInputProps } from "@whatslly/types/UI-V2/FormElements/FormTextInputType";
import type { IUserStore } from "@whatslly/ui-components/services/UserStore";
import { InjectUserStore } from "@whatslly/ui-components/services/UserStore";
import { Label } from "@whatslly/ui-components/v2/BaseElements/Label";
import { FormTextInput } from "@whatslly/ui-components/v2/FormElements/FormTextInput";
import styles from "../../modals/Modals.module.scss";
import { SwitchField } from "../SwitchField";

export const MediaFields: React.FC<{ editableTemplate?: boolean; inputSize?: FormTextInputProps["inputSize"] }> = ({
  editableTemplate,
  inputSize,
}) => {
  const { t } = useTranslation();
  const userStore = useDependencyInjector<IUserStore>(InjectUserStore);
  const { values } = useFormikContext<{ storeMedia?: boolean; lake?: boolean }>();
  const isAdmin = Boolean(userStore.user?.isSuperAdmin || userStore.user?.isAdmin);

  return (
    <>
      <SwitchField name="storeMedia" label={t("destinations_page.store_media")} testId="store-media-switch" />
      {values.storeMedia && !values.lake && (editableTemplate || isAdmin) && (
        <div className={styles.field}>
          <Label className={styles.filedLabel} text={t("destinations_page.media_file_name_template")} />
          <FormTextInput name="mediaFilenameTemplate" paddingInline="none" inputSize={inputSize} disabled={!editableTemplate} />
        </div>
      )}
    </>
  );
};
